export enum PlasterType {
    OdpornyNaZabrudzenia,
    OdpornyNaGrzyby,
    Paroprzepuszczalny
}
